import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import { MdDesktopMac, MdSend, MdSync, MdCancel, MdGetApp, MdPictureAsPdf, MdHistory } from 'react-icons/md';
import { FaFileCode } from 'react-icons/fa';

export default function MonitorMenu({ item, onEmitir, onSincronizar, onCancelar, onBaixarXml, onBaixarPdf, onVerEventos }) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleAction = (action) => {
    switch (action) {
      case 'emitir':
        onEmitir && onEmitir(item);
        break;
      case 'sincronizar':
        onSincronizar && onSincronizar(item);
        break;
      case 'cancelar':
        onCancelar && onCancelar(item);
        break;
      case 'baixarXml':
        onBaixarXml && onBaixarXml(item);
        break;
      case 'baixarPdf':
        onBaixarPdf && onBaixarPdf(item);
        break;
      case 'verEventos':
        onVerEventos && onVerEventos(item);
        break;
      default:
        break;
    }
    handleMenuClose();
  };

  return (
    <div>
      <IconButton
        size="small"
        onClick={handleMenuOpen}
        style={{ padding: '4px', marginLeft: '8px' }}
      >
        <MdDesktopMac size={17} style={{ color: '#122d58' }} />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => handleAction('emitir')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdSend size={18} style={{ color: '#4caf50' }} />
          Emitir
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('sincronizar')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdSync size={18} style={{ color: '#2196F3' }} />
          Sincronizar
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('cancelar')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdCancel size={18} style={{ color: '#f27160' }} />
          Cancelar
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('baixarXml')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <FaFileCode size={16} style={{ color: '#FF9800' }} />
          Baixar XML
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('baixarPdf')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdPictureAsPdf size={18} style={{ color: '#f44336' }} />
          Baixar PDF
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('verEventos')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdHistory size={18} style={{ color: '#9c27b0' }} />
          Ver Eventos
        </MenuItem>
      </Menu>
    </div>
  );
}

